import axios from "axios";

const client = axios.create({
  baseURL: "/api",
  withCredentials: true,
});

export const login = async (username, password) => {
  const response = await client.post("/login", { username, password });
  return response.data;
};

export const logout = async () => {
  await client.post("/logout");
};

export const fetchMessages = async () => {
  const response = await client.get("/messages");
  return response.data;
};

export const fetchMessageById = async (id) => {
  const response = await client.get(`/messages/${id}`);
  return response.data;
};

export const createMessage = async (payload) => {
  const response = await client.post("/messages", payload);
  return response.data;
};

export const updateMessage = async (id, payload) => {
  const response = await client.put(`/messages/${id}`, payload);
  return response.data;
};

export const deleteMessage = async (id) => {
  await client.delete(`/messages/${id}`);
};

export const fetchImages = async () => {
  const response = await client.get("/images");
  return response.data;
};

export const uploadImage = async (file) => {
  const formData = new FormData();
  formData.append("image", file);
  const response = await client.post("/images", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

export const deleteImage = async (imagePath) => {
  const filename = imagePath.split("/").pop();
  await client.delete(`/images/${filename}`);
};

export const fetchSettings = async () => {
  const response = await client.get("/settings");
  return response.data;
};

export const updateSettings = async (payload) => {
  const response = await client.put("/settings", payload);
  return response.data;
};
